import { render, staticRenderFns } from "./SocialPostsListTablePresenceIcons.vue?vue&type=template&id=078279f1&scoped=true&"
import script from "./SocialPostsListTablePresenceIcons.vue?vue&type=script&lang=js&"
export * from "./SocialPostsListTablePresenceIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078279f1",
  null
  
)

export default component.exports